module.exports = __webpack_public_path__ + "img/temperature-humidity-md.374edd99.svg";